export const MAP_LOADED = 'MAP_MAP_LOADED'
export const MAP_LOAD_ERROR = 'MAP_MAP_LOAD_ERROR'
export const CREATE_BUILDING = 'MAP_CREATE_BUILDING'
export const REMOVE_MOUNTAIN = 'MAP_REMOVE_MOUNTAIN'
export const SET_USER_MAP = 'MAP_SET_USER_MAP'
export const CHANGE_TURN = 'MAP_CHANGE_TURN'
export const SET_VISITOR_MAP = 'MAP_SET_VISITOR_MAP'
export const SET_POPUP_DATA = 'MAP_SET_POPUP_DATA'
export const SELECT_CURRENT_TILE = 'MAP_SELECT_CURRENT_TILE'
export const UPGRADE_BUILDING = 'MAP_UPGRADE_BUILDING'
export const DESTROY_BUILDING = 'MAP_DESTROY_BUILDING'
export const LOAD_VISITOR_MAP = 'MAP_LOAD_VISITOR_MAP'
export const REPARE_BUILDING = 'MAP_REPARE_BUILDING'
export const TOGGLE_ATTACK = 'MAP_TOGGLE_ATTACK'
export const ADD_SPRITE = 'MAP_ADD_SPRITE'
export const REMOVE_SPRITE = 'MAP_REMOVE_SPRITE'
export const CLEAR_SPRITES = 'MAP_CLEAR_SPRITES'
export const DELETE_BUILDING = 'MAP_DELETE_BUILDING'
export const DELETE_VISITOR_BUILDING = 'MAP_DELETE_VISITOR_BUILDING'
export const DISPLAYING_BUILDING_CARD = 'MAP_DISPLAYING_BUILDING_CARD'
export const DELETE_EXTRA_BUILDING = 'MAP_DELETE_EXTRA_BUILDING'
export const BACK_TO_RANKING = 'MAP_BACK_TO_RANKING'

export const mapLoaded = () => ({
  type: MAP_LOADED,
})

export const mapLoadError = () => ({
  type: MAP_LOAD_ERROR,
})
export const changeTurn = () => {
  return { type: CHANGE_TURN }
}
export const backToRanking = (bool) => {
  return { type: BACK_TO_RANKING, data: bool }
}
export const addSprite = (id, name, position, customStore = null) => {
  return {
    type: ADD_SPRITE,
    data: {
      id,
      name,
      position,
      customStore: customStore,
    },
  }
}
export const removeSprite = (name) => {
  return { type: REMOVE_SPRITE, data: name }
}
export const clearSprites = () => {
  return { type: CLEAR_SPRITES }
}
export const setDisplayingCard = (name) => {
  return { type: DISPLAYING_BUILDING_CARD, data: name }
}
export const loadVisitorMap = (uid) => {
  return { type: LOAD_VISITOR_MAP, data: uid }
}
export const setUserMap = (map) => {
  return { type: SET_USER_MAP, data: map }
}
export const setVisitorMap = (map) => {
  return { type: SET_VISITOR_MAP, data: map }
}
export const selectCurrentTile = (tile) => {
  return { type: SELECT_CURRENT_TILE, data: tile }
}
export const toggleAttack = () => {
  return { type: TOGGLE_ATTACK }
}
export const createBuilding = (building, tile) => {
  return { type: CREATE_BUILDING, data: { building: building, tile: tile } }
}
export const upgradeBuilding = (building, tile) => {
  return { type: UPGRADE_BUILDING, data: { building: building, tile: tile } }
}
export const destroyBuilding = (building, tile) => {
  return { type: DESTROY_BUILDING, data: { building: building, tile: tile } }
}
export const removeMountain = (tile) => {
  return { type: REMOVE_MOUNTAIN, data: tile }
}
export const setPopupData = (data) => {
  return { type: SET_POPUP_DATA, data: data }
}
export const repareBuilding = (building, tile) => {
  return { type: REPARE_BUILDING, data: { building: building, tile: tile } }
}
export const deleteBuilding = (buildingKey) => {
  return { type: DELETE_BUILDING, data: buildingKey }
}
export const deleteExtraBuilding = (buildingKey) => {
  return { type: DELETE_EXTRA_BUILDING, data: buildingKey }
}
export const deleteVisitorBuilding = (buildingKey) => {
  return { type: DELETE_VISITOR_BUILDING, data: buildingKey }
}
